import type { SVGProps } from 'react';
import * as React from 'react';

/* AUTOGENERATED: DO NOT EDIT */
import _styles from '../logo.module.css';
export const CoinbaseIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path fill="#000" d="M10.02 14.5a4.5 4.5 0 1 1 4.44-5.25H19a9 9 0 1 0 0 1.5h-4.54a4.5 4.5 0 0 1-4.44 3.75" />
  </svg>
);
